<template>
    <div>
        <v-runtime-template :template="template"
                            @open-vr="openVr"
                            @open-streaks="openStreaks">
        </v-runtime-template>

        <div class="contents-popular contents">
            <JsonLd :json="jsonldData" />
            <div class="nearby" v-if="article.attributes.content">
                <div class="inner">
                    <div class="ttl">Nearby <br class="sp-only">Japan Heritage <br class="sp-only">Sites</div>
                    <div class="article">
                        <Carousel
                            v-if="excludeThisArticle(nearByArticles).length > 0"
                            :itemsToShow="3"
                            :itemsToScroll="1"
                            :wrapAround="excludeThisArticle(nearByArticles).length > 2"
                            :snapAlign="'start'"
                            ref="slickNearby"
                        >
                            <template #addons
                                v-if="excludeThisArticle(nearByArticles).length > 2">
                                <div class="navigation">
                                    <button class="slick-arrow slick-prev" @click="carouselPrev('slickNearby')">Prev</button>
                                    <button class="slick-arrow slick-next" @click="carouselNext('slickNearby')">Next</button>
                                </div>
                            </template>
                            <Slide v-for="article in excludeThisArticle(nearByArticles)"
                                   :key="article.key"
                                   style="align-items: unset"
                            >
                                <a href="javascript:void(0)" class="articleItem">
                                    <p class="img" @click="goToStoryPageByCategory(article.attributes.url)">
                                    <span>
                                      <picture>
                                        <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp" />
                                        <img :src="article.attributes.thumbnail_url" :alt="article.attributes.title" />
                                      </picture>
                                    </span>
                                    </p>
                                    <p class="txt" @click="goToStoryPageByCategory(article.attributes.url)" v-html="article.attributes.title"></p>
                                </a>
                            </Slide>
                        </Carousel>
                        <span v-if="excludeThisArticle(nearByArticles).length === 1 || excludeThisArticle(nearByArticles).length === 2"></span>
                        <span v-if="excludeThisArticle(nearByArticles).length === 1"></span>
                        <div class="sp-only">
                            <a href="javascript:void(0)" class="articleItem" v-for="article in excludeThisArticle(nearByArticles)" v-bind:key="article.key">
                                <p class="img" @click="goToStoryPageByCategory(article.attributes.url)">
                                    <span><picture>
                                        <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp">
                                        <img :src="article.attributes.thumbnail_url" :alt="article.attributes.title">
                                    </picture></span>
                                </p>
                                <p class="txt" @click="goToStoryPageByCategory(article.attributes.url)" v-html="article.attributes.title"></p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>

            <div class="otherSites" v-if="article.attributes.content">
                <div class="inner">
                    <div class="ttl">Other Sites in Same Category</div>
                    <div class="article">
                        <Carousel
                            v-if="excludeThisArticle(relatedArticles).length > 0"
                            :itemsToShow="3"
                            :itemsToScroll="1"
                            :wrapAround="true"
                            ref="slickSameCategory"
                        >
                            <template #addons>
                                <div class="navigation">
                                    <button class="slick-arrow slick-prev" @click="carouselPrev('slickSameCategory')">Prev</button>
                                    <button class="slick-arrow slick-next" @click="carouselNext('slickSameCategory')">Next</button>
                                </div>
                            </template>
                            <Slide v-for="article in excludeThisArticle(relatedArticles)" :key="article.key" style="align-items: unset">
                                <a href="javascript:void(0)" class="articleItem">
                                    <p class="img" @click="goToStoryPageByKeyword(article.attributes.url)">
                                        <span>
                                          <picture>
                                            <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp" />
                                            <img :src="article.attributes.thumbnail_url" :alt="article.attributes.title" />
                                          </picture>
                                        </span>
                                    </p>
                                    <p class="txt" @click="goToStoryPageByKeyword(article.attributes.url)" v-html="article.attributes.title"></p>
                                </a>
                            </Slide>
                        </Carousel>
                        <span v-if="excludeThisArticle(relatedArticles).length === 1 || excludeThisArticle(relatedArticles).length === 2"></span>
                        <span v-if="excludeThisArticle(relatedArticles).length === 1"></span>
                        <div class="sp-only">
                            <a href="javascript:void(0)" class="articleItem" v-for="article in excludeThisArticle(relatedArticles)" v-bind:key="article.key">
                                <p class="img" @click="goToStoryPageByKeyword(article.attributes.url)">
                                    <span><picture>
                                            <source :srcset="getWebPUrl(article.attributes.thumbnail_url)" type="image/webp">
                                            <img :src="article.attributes.thumbnail_url" :alt="article.attributes.title">
                                    </picture></span>
                                </p>
                                <p class="txt" @click="goToStoryPageByKeyword(article.attributes.url)" v-html="article.attributes.title"></p>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <vr-player ref="vr"></vr-player>
        <streaks-player ref="streaks"></streaks-player>
    </div>
</template>

<script>
import ApiRouter from "../../components/Systems/ApiRouter";
import VRuntimeTemplate from "vue3-runtime-template";
import VrPlayer from "../../components/VrPlayer/VrPlayer";
import StreaksPlayer from "../../components/StreaksPlayer/StreaksPlayer";
import VideoPlayer from "../../components/VideoPlayer/VideoPlayer";
import moment from 'moment-timezone';
import JsonLd from "@/components/JsonLd/JsonLd.vue";
import { Carousel, Slide } from 'vue3-carousel'
import 'vue3-carousel/dist/carousel.css'


export default {
    name: "Popular",
    mixins: [ApiRouter],
    // eslint-disable-next-line vue/no-unused-components
    components: {JsonLd, StreaksPlayer, VrPlayer, VideoPlayer, VRuntimeTemplate, Carousel, Slide },
    props: {
        breadcrumb: {
            type: Array,
            required: false,
            default: () => [],
        },
        categoryId: {
            type: String,
            required: false,
            default: ''
        },
        keyword: {
            type: String,
            required: false,
            default: ''
        }
    },
    data: function () {
        return {
            page: 'about',
            article: {
                attributes: {
                    title: 'Popular',
                    description: '',
                    keywords: '',
                    content: '',
                    created_at: '',
                    updated_at: ''
                }
            },
            regionIds: [
                '3b3b8d69-262d-434d-a898-104c29603957',
                'f87065e7-c500-427f-bfb3-730405f1d4ec',
                '6ec59d63-f6d2-469f-b190-aac37c80c96b',
                '26a2cce4-c195-4319-b6e1-0265864bf4dc',
                '1326f996-cb65-420f-a6a6-831f75ff763e',
                '09788e7d-5beb-4d3b-b644-32d3a36f4755',
                '735171a6-e699-4b4b-bb47-8082272b171b',
                '4744b2f3-7668-439a-9720-2a18f8107d1b',
                '0c707f65-f788-4cb0-916a-131b42ce72cc',
                'a1f471b5-cb43-4bf1-b076-0348c325560e',
            ],
            categoryIds: [
                'e70710ab-189f-4a39-8a09-866845792550',
                'a42f8d28-d02d-466c-a1e9-0cc31fd7fe99',
                'fa6988ce-f5f3-4953-9c43-c532796fe392',
                'b5840e33-e987-4243-b05a-798a1e29cb9b',
            ],
            articles: [],
            relatedArticles: [],
            nearByArticles: [],
            relatedCategoryId: '',
            nearByKeyword: '',
            previous: '',
            next: '',
            template: '',
            isOpen: false,
            hasPdf: false,
            isVr: false,
            videoUrl: `${process.env.VUE_APP_VIDEO_URL}`,
            settings: {
                arrows: true,
                slidesToShow: 2
            },
            isPC: true,
            pageUrl: '',
            previousUrl: '',
            nextUrl: '',
            jsonld: {
                headline: '', // ページのタイトルを取得する
                description: '', // METAのディスクリプションを取得する
                image: '', // ページのキービジュアルの画像を取得する
                datePublished: '', // ページの公開日を取得する
                dateModified: '', // ページの最終更新日を取得する
            },
            itemListElement: [{
                "@type": "ListItem",
                "position": 1,
                "name": "TOP",
                "item": "https://www.japan.travel/japan-heritage/"
            }],
            jsonldData: {},
            title: '',
        }
    },
    created: function () {
        if (this.$route.params.page) {
            this.showPage(this.$route.params.page);
        }
        this.loadData(this.$route.params.url);
    },
    mounted: function () {
        this.isVr = true;
        this.checkWindowSize();
        window.addEventListener('resize', this.checkWindowSize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.checkWindowSize);
    },
    updated: function () {
        const hash = this.$route.hash;
        if (hash && hash.match(/^#.+$/)) {
            this.$scrollTo(hash);
        }
    },
    beforeRouteUpdate: function (to, from, next) {
        if (this.$route.params.page) {
            this.showPage(this.$route.params.page);
        }
        this.loadData(to.params.url, function () {
            next();
        });
    },
    methods: {
        loadData: function (id, callback = null) {
            this.relatedArticles = [];
            this.nearByArticles = [];

            window.axios.get(this.routes.article(id))
                .then((response) => {
                    this.article = response.data.data;
                    this.url = this.article.attributes.url;
                    if( this.article.attributes.pdf_path !== null ){
                        this.hasPdf = true;
                    }
                    this.template = response.data.data.attributes.content;
                    this.getRelateData();
                    this.getNearByData();
                    this.getArticles();
                    this.initJsonld();
                    this.createBreadcrumbJsonld();
                    this.setTitle();
                    if (callback) {
                        callback();
                    }
                }).catch(error => {
                    // dazaifu.vueを一時的に除外
                    if (error.response.status === 404) {
                        this.navigateTo404();
                    }
            });
        },
        getArticles: function () {
            window.axios.get(this.routes.articles, {
                params: {
                    category_id: this.categoryId,
                    keyword: this.keyword,
                    story: true,
                }
            })
                .then((response) => {
                    this.articles = response.data.data;
                    this.setPaging();
                });
        },
        getRelateData: function () {
            if (this.article.attributes.keywords) {
                const keywords = this.article.attributes.keywords.split(',');
                this.nearByKeyword = keywords[Math.floor(Math.random() * keywords.length)]
                this.setSearchRelatedArticles(this.nearByKeyword);
            }
        },
        setSearchRelatedArticles: function (keyword) {
            window.axios.get(this.routes.articles, {
                params: {
                    keyword: keyword,
                    story: true,
                }
            })
                .then((response) => {
                    this.relatedArticles = response.data.data;
                });
        },
        getNearByData: function () {
            this.article.relationships.categories.some((category) => {
                const exist = this.regionIds.includes(category.id);
                if (exist) {
                    this.relatedCategoryId = category.id;
                    this.setSearchNearByArticles(category.id);
                    return true;
                }
            });
        },
        setSearchNearByArticles: function (category_id) {
            window.axios.get(this.routes.articles, {
                params: {
                    category_id: category_id,
                    story: true,
                }
            })
                .then((response) => {
                    this.nearByArticles = response.data.data;
                })
        },
        setPaging: function () {
            const id = this.article.attributes.id;
            const max = this.articles.length -1;
            let index = this.articles.findIndex(function (article) {
                return article.id === id;
            });
            switch (index) {
                case -1:
                    return;
                case 0:
                    this.previous = this.articles[max].id;
                    this.next = this.articles[index + 1].id;
                    this.previousUrl = this.articles[max].attributes.url;
                    this.nextUrl = this.articles[index + 1].attributes.url;
                    break;
                case max:
                    this.previous = this.articles[index - 1].id;
                    this.next = this.articles[0].id;
                    this.previousUrl = this.articles[index - 1].attributes.url;
                    this.nextUrl = this.articles[0].attributes.url;
                    break;
                default:
                    this.previous = this.articles[index - 1].id;
                    this.next = this.articles[index + 1].id;
                    this.previousUrl = this.articles[index - 1].attributes.url;
                    this.nextUrl = this.articles[index + 1].attributes.url;
                    break;
            }
        },
        download: function () {
            window.axios.get(this.routes.downloadArticles(this.$route.params.id))
                .then((response) => {
                    this.sendDownloadResponse(response.data.download_url);
                });
        },
        sendDownloadResponse: function (url) {
            const link = document.createElement('a');
            link.href = url;
            link.click();
        },
        showPage: function (page) {
            if(this.$refs['video-player']){
                this.$refs['video-player'].pauseVideo();
            }
            this.page = page;
            this.scroll();
        },
        scroll: function () {
            scrollTo({
                top: 0
            });
        },
        openVr: function ($event) {
            this.$refs.vr.open($event);
        },
        openStreaks: function ($event) {
            this.$refs.streaks.open($event);
        },
        // goToStoryPage: function (id) {
        //     this.$router.push({name: 'Popular', params: {id: id, page: 'about', breadcrumb: 'recommend'}});
        // },
        goToStoryPageByCategory: function (url) {
            if (this.categoryId !== '') this.relatedCategoryId = this.categoryId;
            this.$router.push({name: 'Popular', params: {page: 'about', breadcrumb: 'recommend', url: url, categoryId: this.relatedCategoryId}});
        },
        goToStoryPageByKeyword: function (url) {
            if (this.keyword !== '') this.nearByKeyword = this.keyword;
            this.$router.push({name: 'Popular', params: {page: 'about', breadcrumb: 'recommend', url: url, keyword: this.nearByKeyword}});
        },
        checkWindowSize() {
            this.isPC = window.innerWidth >= 768;
        },
        getWebPUrl(url) {
            return url.replace('/images', '/webp').replace(/\.(jpg|jpeg|png)$/, ".webp");
        },
        initJsonld: function() {
            this.jsonld.headline = this.article.attributes.title;
            this.jsonld.description = this.article.description;
            this.jsonld.image = this.article.attributes.thumbnail_url;
            this.jsonld.datePublished = moment(this.article.attributes.created_at).tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss');
            this.jsonld.dateModified = moment(this.article.attributes.updated_at).tz('Asia/Tokyo').format('YYYY-MM-DD HH:mm:ss');
            this.jsonldData = {
                "@context": "https://schema.org",
                "@graph": [
                    {
                        "@type": "Article",
                        "mainEntityOfPage": window.location.href,
                        "headline": this.jsonld.headline,
                        "description": this.jsonld.description,
                        "image": [
                            this.jsonld.image
                        ],
                        "datePublished": this.jsonld.datePublished,
                        "dateModified": this.jsonld.dateModified,
                        "author": [{
                            "@type": "Organization",
                            "name": "Japan National Tourism Organization",
                            "url": "https://www.japan.travel/japan-heritage/"
                        }]
                    },
                    {
                        "@type": "BreadcrumbList",
                        "itemListElement": [
                            this.itemListElement
                        ]
                    }
                ]
            }
        },
        createBreadcrumbJsonld: function() {
            switch (this.breadcrumb.length) {
                case 1:
                    this.itemListElement.push(
                        {
                            "@type": "ListItem",
                            "position": 2,
                            "name": this.breadcrumb[0],
                            "item": "https://www.japan.travel/japan-heritage/"
                        },
                        {
                            "@type": "ListItem",
                            "position": 3,
                            "name": this.article.attributes.title,
                            "item": "https://www.japan.travel/japan-heritage/" + this.article.attributes.url
                        }
                    )
                    break
                case 2:
                    this.itemListElement.push(
                        {
                            "@type": "ListItem",
                            "position": 2,
                            "name": this.breadcrumb[0],
                            "item": "https://www.japan.travel/japan-heritage/"
                        },
                        {
                            "@type": "ListItem",
                            "position": 3,
                            "name": this.breadcrumb[1],
                            "item": "https://www.japan.travel/japan-heritage/"
                        },
                        {
                            "@type": "ListItem",
                            "position": 4,
                            "name": this.article.attributes.title,
                            "item": "https://www.japan.travel/japan-heritage/" + this.article.attributes.url
                        }
                    )
                    break
                default:
                    this.itemListElement.push(
                        {
                            "@type": "ListItem",
                            "position": 2,
                            "name": this.article.attributes.title,
                            "item": "https://www.japan.travel/japan-heritage/" + this.article.attributes.url
                        }
                    )
                    break
            }
        },
        navigateTo404() {
            this.$router.push('/404');
        },
        carouselPrev(refName) {
            this.$refs[refName]?.prev();
        },
        carouselNext(refName) {
            this.$refs[refName]?.next();
        },
        setTitle() {
            document.title = `${this.article.attributes.title.replace('<br>', '')} | Japan Heritage`
        }
    },
    computed: {
        excludeThisArticle() {
            return (articles) => {
                return (articles || []).filter(article => article && article.id && this.article.id !== article.id);
            }
        }
    }
}
</script>

<style src="./Popular.scss" lang="scss"/>
